var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "container-fluid shadow"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md text-left",
    staticStyle: {
      "padding-left": "20px"
    }
  }, [_c('label', {
    staticClass: "text-left",
    staticStyle: {
      "border-bottom": "1px solid lightgray",
      "width": "100%"
    }
  }, [_vm._v(_vm._s(_vm.shopCart2AltOptions.ragioneSocialeLbl))])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 text-left",
    staticStyle: {
      "padding-left": "27px"
    }
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.ragioneSocialeValue))])])]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 text-left",
    staticStyle: {
      "padding-left": "20px"
    }
  }, [_c('label', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.shopCart2AltOptions.richiedenteLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 text-left"
  }, [_c('label', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.shopCart2AltOptions.altroRichiedenteLbl))])])]), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.shopCart2AltOptions.nomeCognomeLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.shopCart2AltOptions
    },
    model: {
      value: (_vm.ragioneSocialeValue),
      callback: function($$v) {
        _vm.ragioneSocialeValue = $$v
      },
      expression: "ragioneSocialeValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nomeCognomeRichiedenteValue),
      expression: "nomeCognomeRichiedenteValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "type": "text",
      "id": "nomeCognomeRichiedenteId"
    },
    domProps: {
      "value": (_vm.nomeCognomeRichiedenteValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nomeCognomeRichiedenteValue = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.shopCart2AltOptions.nomeCognomeLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.shopCart2AltOptions
    },
    model: {
      value: (_vm.ragioneSocialeValue),
      callback: function($$v) {
        _vm.ragioneSocialeValue = $$v
      },
      expression: "ragioneSocialeValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nomeCognomeAltroRicValue),
      expression: "nomeCognomeAltroRicValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "type": "text",
      "id": "nomeCognomeAltroRicId"
    },
    domProps: {
      "value": (_vm.nomeCognomeAltroRicValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nomeCognomeAltroRicValue = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "padding-left": "1px"
    }
  }, [_c('button', {
    staticStyle: {
      "width": "130px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.altroRichiedenteClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.shopCart2AltOptions.altroRichiedenteLbl))])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.shopCart2AltOptions.mailLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.shopCart2AltOptions
    },
    model: {
      value: (_vm.mailRichiedenteValue),
      callback: function($$v) {
        _vm.mailRichiedenteValue = $$v
      },
      expression: "mailRichiedenteValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mailRichiedenteValue),
      expression: "mailRichiedenteValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "type": "text",
      "id": "mailRichiedenteId"
    },
    domProps: {
      "value": (_vm.mailRichiedenteValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mailRichiedenteValue = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.shopCart2AltOptions.mailLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.shopCart2AltOptions
    },
    model: {
      value: (_vm.mailAltroRicValue),
      callback: function($$v) {
        _vm.mailAltroRicValue = $$v
      },
      expression: "mailAltroRicValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.mailAltroRicValue),
      expression: "mailAltroRicValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "type": "text",
      "id": "mailAltroRicID"
    },
    domProps: {
      "value": (_vm.mailAltroRicValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.mailAltroRicValue = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.altroRichSelected) ? _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "padding-left": "1px"
    }
  }, [_c('button', {
    staticStyle: {
      "width": "130px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.annullaAltroRichiedente($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.shopCart2AltOptions.annullaAltroRichiedenteBtnLbl))])]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.shopCart2AltOptions.faxLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.shopCart2AltOptions
    },
    model: {
      value: (_vm.faxRichiedenteValue),
      callback: function($$v) {
        _vm.faxRichiedenteValue = $$v
      },
      expression: "faxRichiedenteValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.faxRichiedenteValue),
      expression: "faxRichiedenteValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "type": "text",
      "id": "faxRichiedenteId"
    },
    domProps: {
      "value": (_vm.faxRichiedenteValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.faxRichiedenteValue = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.shopCart2AltOptions.faxLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.shopCart2AltOptions
    },
    model: {
      value: (_vm.faxAltroRicValue),
      callback: function($$v) {
        _vm.faxAltroRicValue = $$v
      },
      expression: "faxAltroRicValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.faxAltroRicValue),
      expression: "faxAltroRicValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "type": "text",
      "id": "faxAltroRicId"
    },
    domProps: {
      "value": (_vm.faxAltroRicValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.faxAltroRicValue = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v(" ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.shopCart2AltOptions.telLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.shopCart2AltOptions
    },
    model: {
      value: (_vm.telRichiedenteValue),
      callback: function($$v) {
        _vm.telRichiedenteValue = $$v
      },
      expression: "telRichiedenteValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telRichiedenteValue),
      expression: "telRichiedenteValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "type": "text",
      "id": "telRichiedenteId"
    },
    domProps: {
      "value": (_vm.telRichiedenteValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telRichiedenteValue = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.shopCart2AltOptions.telLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.shopCart2AltOptions
    },
    model: {
      value: (_vm.telAltroRicValue),
      callback: function($$v) {
        _vm.telAltroRicValue = $$v
      },
      expression: "telAltroRicValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.telAltroRicValue),
      expression: "telAltroRicValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "type": "text",
      "id": "telAltroRicId"
    },
    domProps: {
      "value": (_vm.telAltroRicValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.telAltroRicValue = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v(" ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5 text-left",
    staticStyle: {
      "padding-left": "20px"
    }
  }, [_c('label', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.shopCart2AltOptions.indirizzoConsPredLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7 text-left"
  }, [_c('label', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.shopCart2AltOptions.altroIndirizzoConsLbl))])])]), _vm._v(" "), _vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.shopCart2AltOptions.indirizzoConsegnaLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.shopCart2AltOptions
    },
    model: {
      value: (_vm.indirizzoConsegnaValue),
      callback: function($$v) {
        _vm.indirizzoConsegnaValue = $$v
      },
      expression: "indirizzoConsegnaValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.indirizzoConsegnaValue),
      expression: "indirizzoConsegnaValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "type": "text",
      "id": "indirizzoConsegnaId"
    },
    domProps: {
      "value": (_vm.indirizzoConsegnaValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.indirizzoConsegnaValue = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.shopCart2AltOptions.indirizzoConsegnaLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.shopCart2AltOptions
    },
    model: {
      value: (_vm.indirizzoAltroValue),
      callback: function($$v) {
        _vm.indirizzoAltroValue = $$v
      },
      expression: "indirizzoAltroValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.indirizzoAltroValue),
      expression: "indirizzoAltroValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.indirizzoAltroValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.indirizzoAltroValue = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "padding-left": "1px"
    }
  }, [_c('button', {
    staticStyle: {
      "width": "130px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.altroIndirizzoClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.shopCart2AltOptions.altroIndirizzoBtnLbl))])])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.shopCart2AltOptions.capConsegnaLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.shopCart2AltOptions
    },
    model: {
      value: (_vm.capConsegnaValue),
      callback: function($$v) {
        _vm.capConsegnaValue = $$v
      },
      expression: "capConsegnaValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.capConsegnaValue),
      expression: "capConsegnaValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "type": "text",
      "id": "capConsegnaId"
    },
    domProps: {
      "value": (_vm.capConsegnaValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.capConsegnaValue = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.shopCart2AltOptions.capConsegnaLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.shopCart2AltOptions
    },
    model: {
      value: (_vm.capAltroValue),
      callback: function($$v) {
        _vm.capAltroValue = $$v
      },
      expression: "capAltroValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.capAltroValue),
      expression: "capAltroValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "type": "text",
      "id": "capAltroId"
    },
    domProps: {
      "value": (_vm.capAltroValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.capAltroValue = $event.target.value
      }
    }
  })])]), _vm._v(" "), (_vm.altroIndiSelected) ? _c('div', {
    staticClass: "col-md-2",
    staticStyle: {
      "padding-left": "1px"
    }
  }, [_c('button', {
    staticStyle: {
      "width": "130px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.annullaAltroIndirizzo($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.shopCart2AltOptions.annullaAltroIndirizzoBtnLbl))])]) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.shopCart2AltOptions.localitaConsegnaLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.shopCart2AltOptions
    },
    model: {
      value: (_vm.localitaConsegnaValue),
      callback: function($$v) {
        _vm.localitaConsegnaValue = $$v
      },
      expression: "localitaConsegnaValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localitaConsegnaValue),
      expression: "localitaConsegnaValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "type": "text",
      "id": "localitaConsegnaId"
    },
    domProps: {
      "value": (_vm.localitaConsegnaValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.localitaConsegnaValue = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.shopCart2AltOptions.localitaConsegnaLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.shopCart2AltOptions
    },
    model: {
      value: (_vm.localitaAltroValue),
      callback: function($$v) {
        _vm.localitaAltroValue = $$v
      },
      expression: "localitaAltroValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.localitaAltroValue),
      expression: "localitaAltroValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "type": "text",
      "id": "localitaAltroId"
    },
    domProps: {
      "value": (_vm.localitaAltroValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.localitaAltroValue = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v(" ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.shopCart2AltOptions.provinciaConsegnaLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.shopCart2AltOptions
    },
    model: {
      value: (_vm.provinciaConsegnaValue),
      callback: function($$v) {
        _vm.provinciaConsegnaValue = $$v
      },
      expression: "provinciaConsegnaValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provinciaConsegnaValue),
      expression: "provinciaConsegnaValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "type": "text",
      "id": "provinciaConsegnaId"
    },
    domProps: {
      "value": (_vm.provinciaConsegnaValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.provinciaConsegnaValue = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.shopCart2AltOptions.provinciaConsegnaLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.shopCart2AltOptions
    },
    model: {
      value: (_vm.provinciaAltroValue),
      callback: function($$v) {
        _vm.provinciaAltroValue = $$v
      },
      expression: "provinciaAltroValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.provinciaAltroValue),
      expression: "provinciaAltroValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "type": "text",
      "id": "provinciaAltroId"
    },
    domProps: {
      "value": (_vm.provinciaAltroValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.provinciaAltroValue = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v(" ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.shopCart2AltOptions.nazioneConsegnaLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.shopCart2AltOptions
    },
    model: {
      value: (_vm.nazioneConsegnaValue),
      callback: function($$v) {
        _vm.nazioneConsegnaValue = $$v
      },
      expression: "nazioneConsegnaValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nazioneConsegnaValue),
      expression: "nazioneConsegnaValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "type": "text",
      "id": "nazioneConsegnaId"
    },
    domProps: {
      "value": (_vm.nazioneConsegnaValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nazioneConsegnaValue = $event.target.value
      }
    }
  })])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.shopCart2AltOptions.regioneAltroLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.shopCart2AltOptions
    },
    model: {
      value: (_vm.regioneAltroValue),
      callback: function($$v) {
        _vm.regioneAltroValue = $$v
      },
      expression: "regioneAltroValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.regioneAltroValue),
      expression: "regioneAltroValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "type": "text",
      "id": "regioneAltroId"
    },
    domProps: {
      "value": (_vm.regioneAltroValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.regioneAltroValue = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v(" ")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_vm._v("\n                             \n                        ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_c('span', {
    staticClass: "align-middle"
  }, [_vm._v(_vm._s(_vm.shopCart2AltOptions.nazioneConsegnaLbl))])]), _vm._v(" "), _c('input-w', {
    attrs: {
      "configs": _vm.shopCart2AltOptions
    },
    model: {
      value: (_vm.nazioneAltroValue),
      callback: function($$v) {
        _vm.nazioneAltroValue = $$v
      },
      expression: "nazioneAltroValue"
    }
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nazioneAltroValue),
      expression: "nazioneAltroValue"
    }],
    staticClass: "form-control form-control-cust",
    attrs: {
      "type": "text",
      "id": "nazioneAltroId"
    },
    domProps: {
      "value": (_vm.nazioneAltroValue)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.nazioneAltroValue = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  }, [_vm._v(" ")])], 1)])]), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticClass: "controls col-sm-3"
  }, [_c('button', {
    staticClass: "btn btn-primary-default",
    staticStyle: {
      "width": "130px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.previousClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.shopCart2AltOptions.indietroBtnLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "controls col-sm-3"
  }, [_c('button', {
    staticClass: "btn btn-primary-default",
    staticStyle: {
      "width": "130px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.forwardClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.shopCart2AltOptions.avantiBtnLbl))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-1"
  }), _vm._v(" "), _c('cfg', {
    attrs: {
      "cid": "shopCart.nuovoOrdineBtn",
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "controls col-sm-3"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    staticStyle: {
      "width": "140px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.cleanShopCartClick($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$Jed.firstUpperTranslate('new order')))])])])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-2"
  })]), _vm._v(" "), _vm._m(4)])]), _vm._v(" "), _c('span')])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md "
  }, [_vm._v("\n                             \n                        ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "border-top": "1px solid lightgray",
      "content": "''",
      "top": "20px",
      "right": "10em",
      "vertical-align": "top",
      "bottom": "0",
      "width": "100%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "border-top": "1px solid lightgray",
      "content": "''",
      "top": "20px",
      "right": "10em",
      "vertical-align": "top",
      "bottom": "0",
      "width": "100%"
    }
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "border-top": "1px solid lightgray",
      "content": "''",
      "top": "20px",
      "right": "10em",
      "vertical-align": "top",
      "bottom": "0",
      "width": "100%"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_c('div', {
    staticStyle: {
      "display": "inline-block",
      "border-top": "1px solid lightgray",
      "content": "''",
      "top": "20px",
      "right": "10em",
      "vertical-align": "top",
      "bottom": "0",
      "width": "100%"
    }
  })])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-5"
  }, [_vm._v(" ")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-7"
  }, [_vm._v(" ")])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md"
  }, [_vm._v(" \n                        ")])])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-493a5af7","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/shopcart/ShopCart2Alternate.vue
// module id = 1678
// module chunks = 1